export const normalize = value => (value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');

export const normalizeGender = value => {
    const normalizedValue = normalize(value);

    if (['m', 'male'].includes(normalizedValue)) return 'male';
    if (['w', 'f', 'female'].includes(normalizedValue)) return 'female';
    if (['u', 'unknown'].includes(normalizedValue)) return 'unknown';
    return normalizedValue;
};

export const validateHcpcRecord = (
    record,
    enteredDetails,
    { skipHcpcPersonValidation = false } = {}
) => {
    if (!record) {
        return { accepted: false, reason: 'No record selected' };
    }

    if (skipHcpcPersonValidation) {
        return { accepted: true, reason: null };
    }

    const firstMatch = normalize(enteredDetails?.firstName) === normalize(record.First_Name);
    const surnameMatch = normalize(enteredDetails?.surname) === normalize(record.Last_Name);

    let genderMatch = true;

    const enteredGender = normalizeGender(enteredDetails?.gender);
    const recordGender = normalizeGender(record?.Gender);

    const shouldCheckGender = enteredGender && enteredGender !== 'unknown' && recordGender;

    if (shouldCheckGender) {
        genderMatch = enteredGender === recordGender;
    }

    if (!firstMatch) {
        return { accepted: false, reason: 'First name does not match HCPC record' };
    }

    if (!surnameMatch) {
        return { accepted: false, reason: 'Surname does not match HCPC record' };
    }

    if (!genderMatch) {
        return { accepted: false, reason: 'Gender does not match HCPC record' };
    }

    return { accepted: true, reason: null };
};
